declare global {
    module Phaser {
        namespace Geom {
            export interface Rectangle {
                trace(): string;
            }
        }
        namespace GameObjects {
            export interface GameObject {
                /**
                 * Removes last Container item and returns it
                 */
                removeLast(): GameObject;
                /**
                 * Removes number of container items from the back, and returns them
                 */
                removeLastCount(count: number): GameObject[];
            }
        }
    }
}

export function InitExtensionMethods(): void
{ 
    // trace IS recognized here
    Phaser.Geom.Rectangle.prototype.trace = function (): string
    {
        return `${this.x} ${this.y} ${this.width} ${this.height}`;
    }
    /**
     * Removes last Container item and returns it
     * @return child: Phaser.GameObjects.GameObject removed game object
     */
    Phaser.GameObjects.Container.prototype.removeLast = function (): Phaser.GameObjects.GameObject | null
    {
        if (this.length > 0) {
            const lastIndex: number = this.length - 1;
            const child: Phaser.GameObjects.GameObject = this.getAt(lastIndex);
            this.removeAt(lastIndex);
            return child;
        }
        return null;
    }
    
    /**
     * Removes number of container items from the back, and returns them 
     * @param count number of items to remove form the back. This is clamped at container length.
     */
    Phaser.GameObjects.Container.prototype.removeLastCount = function (count: number): Phaser.GameObjects.GameObject[]
    {
        const returnItems: Phaser.GameObjects.GameObject[] = [];
        let removeItemsCount: number = Math.min(this.length, count);
        while (removeItemsCount--) {
            const removedItem: Phaser.GameObjects.GameObject = this.removeLast();
            if (removedItem != null) {
                returnItems.push(removedItem);
            }
        }
        return returnItems;
    }
    
}